import type { TenantTier } from "@/types/tenant";

/**
 * The tier values, so comparisons name the vocabulary instead of
 * repeating string literals (`CONTEXT.md`: "Shared tier / Dedicated
 * tier"). Runtime counterpart of the `TenantTier` union, kept here for
 * the same reason `GRANTING_STATUSES` lives beside
 * `BillingSubscriptionStatus`: `types/` is type-only.
 *
 * `satisfies { [K in TenantTier]: K }` rather than a bare `as const` so
 * the object cannot drift from the union it enumerates, in any of the
 * three directions: a value the type does not have fails here, dropping
 * a member the type still has fails, and — because each key is mapped to
 * its *own* literal — so does pairing a key with the wrong value. Keyed
 * by `string` it would only have constrained the values, and a deleted
 * member would have compiled cleanly and failed at the call site.
 * `Record<TenantTier, TenantTier>` would have admitted the swap: these
 * strings are a wire contract (the `X-Tier` header, the OTEL gateway's
 * routing rule), so `{ shared: "dedicated" }` inverts every tier verdict
 * in the app on a green build.
 */
export const TENANT_TIER = {
  shared: "shared",
  dedicated: "dedicated",
} as const satisfies { [K in TenantTier]: K };
